module.exports = __webpack_public_path__ + "img/up.916adb38.png";